import { ReactComponent as OpenBookSvg } from '../../assets/icons/open-book.svg';

export default function OpenBookIcon() {
  return <OpenBookSvg aria-hidden="true" focusable="false" />;
}
